<template>
  <div class="admin-room-container figma-property-page">
    <div class="figma-white-card">
      <div class="figma-page-header">
        <div class="figma-page-title">{{ $t('areaFeedback.pageTitle') }}</div>
        <div class="figma-header-divider"></div>
        <div class="figma-header-row">
          <div class="figma-btn-group">
            <el-button size="small" class="figma-btn-refresh" title="刷新" @click="_queryMethod">
              <i class="el-icon-refresh"></i>
            </el-button>
          </div>
          <div class="figma-search-group">
            <el-input size="small" v-model="conditions.name"
              :placeholder="$t('areaFeedback.search.keywordPlaceholder')" class="figma-search-input" clearable />
            <el-button size="small" class="figma-btn-search" @click="_queryMethod">
              <i class="el-icon-search"></i>{{ $t('common.search') }}
            </el-button>
          </div>
        </div>
      </div>

      <div class="figma-table-section">
        <el-table :data="tableData" style="width: 100%" height="100%" :header-cell-style="headerCellStyle" :cell-style="cellStyle">
          <el-table-column prop="communityName" :label="$t('areaFeedback.table.communityName')" min-width="160">
            <template slot-scope="scope"><span class="figma-community-name">{{ scope.row.communityName || '-' }}</span></template>
          </el-table-column>
          <el-table-column prop="roomNum" :label="$t('areaFeedback.table.roomNum')" min-width="100" align="center">
            <template slot-scope="scope">{{ scope.row.roomNum || '-' }}</template>
          </el-table-column>
          <el-table-column prop="builtUpArea" :label="$t('areaFeedback.table.builtUpArea')" min-width="120" align="center">
            <template slot-scope="scope">{{ scope.row.builtUpArea != null ? scope.row.builtUpArea : '-' }}</template>
          </el-table-column>
          <el-table-column prop="feedbackArea" :label="$t('areaFeedback.table.feedbackArea')" min-width="120" align="center">
            <template slot-scope="scope">{{ scope.row.feedbackArea != null ? scope.row.feedbackArea : '-' }}</template>
          </el-table-column>
          <el-table-column prop="remark" :label="$t('areaFeedback.table.remark')" min-width="160" align="center">
            <template slot-scope="scope">{{ scope.row.remark || '-' }}</template>
          </el-table-column>
          <el-table-column prop="createTime" :label="$t('areaFeedback.table.createTime')" min-width="160" align="center">
            <template slot-scope="scope">{{ scope.row.createTime || '-' }}</template>
          </el-table-column>
          <el-table-column prop="auditStatus" :label="$t('areaFeedback.table.state')" min-width="100" align="center">
            <template slot-scope="scope">
              <span :class="['status-tag', getAuditStateClass(getAuditStatus(scope.row))]">{{ getAuditStateText(getAuditStatus(scope.row)) }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('common.operation')" fixed="right" width="124">
            <template slot-scope="scope">
              <span v-if="isPendingAudit(scope.row)" class="action-links">
                <a class="action-link action-link-approve" @click="_approveRow(scope.row)">{{ $t('areaFeedback.action.approve') }}</a>
                <span class="link-separator"></span>
                <a class="action-link action-link-danger" @click="_rejectRow(scope.row)">{{ $t('areaFeedback.action.reject') }}</a>
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="figma-pagination">
        <span class="pagination-total">共{{ pagination.total }}条</span>
        <el-pagination :current-page="pagination.current" :page-sizes="[10, 20, 30, 50]"
          :page-size="pagination.size" layout="prev, pager, next, jumper" :total="pagination.total"
          @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        <el-select v-model="pagination.size" size="small" class="pagination-size-select">
          <el-option label="10条/页" :value="10" /><el-option label="20条/页" :value="20" /><el-option label="50条/页" :value="50" />
        </el-select>
      </div>
    </div>
  </div>
</template>

<script>
import { listAreaFeedback, auditAreaFeedback } from '@/api/platform/platformApi'

export default {
  name: 'AreaFeedbackList',
  data() {
    return {
      conditions: { name: '' },
      tableData: [],
      pagination: { current: 1, size: 10, total: 0 }
    }
  },
  created() { this._initMethod() },
  methods: {
    _initMethod() { this._listData(this.pagination.current, this.pagination.size) },
    _listData(page, size) {
      const params = { ...this.conditions, page, row: size }
      listAreaFeedback(params).then(res => {
        this.tableData = Array.isArray(res.data) ? res.data : []
        this.pagination.total = res.total || 0
      }).catch(error => {
        console.error('请求失败处理', error)
      })
    },
    _queryMethod() { this.pagination.current = 1; this._listData(this.pagination.current, this.pagination.size) },
    _approveRow(row) {
      this.$confirm(this.$t('areaFeedback.audit.approveConfirm'), this.$t('areaFeedback.audit.approveTitle'), {
        confirmButtonText: this.$t('areaFeedback.action.approve'), cancelButtonText: this.$t('areaFeedback.audit.cancel'), type: 'warning'
      }).then(() => {
        auditAreaFeedback({ feedbackId: row.feedbackId, roomId: row.roomId, feedbackArea: row.feedbackArea, auditStatus: '1' }).then(() => { this.$message.success(this.$t('areaFeedback.audit.approveSuccess')); this._queryMethod() }).catch(error => { console.error('审核失败', error) })
      }).catch(() => {})
    },
    _rejectRow(row) {
      this.$confirm(this.$t('areaFeedback.audit.rejectConfirm'), this.$t('areaFeedback.audit.rejectTitle'), {
        confirmButtonText: this.$t('areaFeedback.action.reject'), cancelButtonText: this.$t('areaFeedback.audit.cancel'), type: 'warning'
      }).then(() => {
        auditAreaFeedback({ feedbackId: row.feedbackId, roomId: row.roomId, feedbackArea: row.feedbackArea, auditStatus: '-1' }).then(() => { this.$message.success(this.$t('areaFeedback.audit.rejectSuccess')); this._queryMethod() }).catch(error => { console.error('审核失败', error) })
      }).catch(() => {})
    },
    getAuditStatus(row) {
      return row.auditStatus !== undefined && row.auditStatus !== null ? String(row.auditStatus) : String(row.statusCd || '')
    },
    isPendingAudit(row) {
      return this.getAuditStatus(row) === '0'
    },
    getAuditStateClass(status) {
      return { '0': 'status-warning', '1': 'status-occupied', '-1': 'status-danger' }[status] || 'status-unsold'
    },
    getAuditStateText(status) {
      return { '0': this.$t('areaFeedback.table.statePending'), '1': this.$t('areaFeedback.table.stateApproved'), '-1': this.$t('areaFeedback.table.stateRejected') }[status] || '-'
    },
    handleSizeChange(val) { this.pagination.size = val; this._listData(this.pagination.current, val) },
    handleCurrentChange(val) { this.pagination.current = val; this._listData(val, this.pagination.size) },
    headerCellStyle() { return { background: '#EBF2FA', color: '#364153', fontSize: '14px', fontWeight: '500', fontFamily: 'PingFang SC' } },
    cellStyle({ row }) {
      const rowIndex = this.tableData.indexOf(row)
      return rowIndex % 2 === 1 ? { background: '#F8FBFF', color: '#1D2129', fontSize: '14px', fontFamily: 'PingFang SC' } : { background: 'white', color: '#1D2129', fontSize: '14px', fontFamily: 'PingFang SC' }
    }
  }
}
</script>

<style scoped>
.admin-room-container { height: calc(100vh - 60px); background: #EBF2FA; padding: 0; overflow: hidden; box-sizing: border-box; display: flex; flex-direction: column; }
.figma-white-card { background: white; border-radius: 0 0 12px 12px; flex: 1; min-height: 0; display: flex; flex-direction: column; }
.figma-page-header { display: flex; flex-direction: column; align-items: flex-start; padding: 20px 24px; gap: 12px; }
.figma-page-title { font-size: 16px; font-weight: 500; color: #1D2129; font-family: 'PingFang SC'; margin-bottom: 8px; }
.figma-header-divider { width: 100%; height: 1px; background: #DCE6F5; margin-bottom: 16px; }
.figma-header-row { display: flex; align-items: center; justify-content: space-between; width: 100%; }
.figma-btn-group { display: flex; align-items: center; gap: 8px; }
.figma-btn-refresh { height: 38px; width: 38px; border-radius: 10px !important; border: 1px solid #DCE6F5 !important; background: white !important; color: #6A7282 !important; display: inline-flex; align-items: center; justify-content: center; }
.figma-btn-refresh:hover { border-color: #0E76FF !important; color: #0E76FF !important; }
.figma-search-group { display: flex; align-items: center; gap: 8px; margin-left: auto; }
.figma-search-input { width: 256px; height: 38px; }
.figma-search-input >>> .el-input__inner { border-radius: 10px; border: none; outline: 1px #0E76FF solid; outline-offset: -1px; height: 38px; font-size: 14px; background: white; }
.figma-btn-search { height: 38px; border-radius: 10px !important; border: none !important; outline: 1px #0E76FF solid !important; outline-offset: -1px; color: #0E76FF !important; background: white !important; font-size: 14px; font-weight: 500; padding: 0 16px; display: inline-flex; align-items: center; gap: 6px; }
.figma-btn-search:hover { background: rgba(14, 118, 255, 0.08) !important; }
.figma-table-section { flex: 1; padding: 0 24px; overflow: auto; }
.figma-table-section >>> .el-table { border-radius: 8px; overflow: hidden; border: none; }
.figma-table-section >>> .el-table__header th { background: #EBF2FA !important; border: none !important; }
.figma-table-section >>> .el-table__body td { border: none !important; border-bottom: 1px solid #F0F0F0 !important; }
.figma-table-section >>> .el-table__body tr:nth-child(even) td { background: #F8FBFF; }
.figma-table-section >>> .el-table::before { display: none; }
.figma-community-name { color: #0E76FF; font-weight: 500; }
.status-tag { display: inline-block; padding: 4px 12px; border-radius: 8px; font-size: 14px; font-weight: 400; }
.status-occupied { background: rgba(33, 185, 86, 0.10); color: #21B956; border: 1px solid #21B956; }
.status-unsold { background: rgba(140, 155, 180, 0.10); color: #8C9BB4; border: 1px solid #8C9BB4; }
.status-danger { background: rgba(251, 44, 54, 0.10); color: #FB2C36; border: 1px solid #FB2C36; }
.status-warning { background: rgba(255, 153, 0, 0.10); color: #FF9900; border: 1px solid #FF9900; }
.action-links { display: flex; align-items: center; gap: 8px; }
.action-link { color: #0E76FF; font-size: 14px; cursor: pointer; text-decoration: none; }
.action-link:hover { text-decoration: underline; }
.action-link-approve { color: #21B956; }
.action-link-danger { color: #FB2C36; }
.link-separator { color: #DCE6F5; }
.figma-pagination { display: flex; align-items: center; justify-content: flex-end; padding: 16px 24px; gap: 16px; border-top: 1px solid #DCE6F5; }
.pagination-total { font-size: 14px; color: #1D2129; }
.figma-pagination >>> .el-pagination { display: flex; align-items: center; }
.figma-pagination >>> .el-pager li { border-radius: 8px; }
.figma-pagination >>> .el-pager li.active { background: #E8F3FF; color: #0E76FF; }
.pagination-size-select { width: 92px; }
.pagination-size-select >>> .el-input__inner { border-radius: 8px; background: #F2F3F5; border: none; font-size: 14px; }
</style>
